var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:['header', _vm.props.stroked ? 'stroked' : false]},[_c('h4',[_vm._v(_vm._s(_vm.props.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }